module.exports = {
	"ha": "fha",
	"id": 5.7,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by HSDA, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -80,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 95.23809523809523,
						"dataLabels": {
							"enabled": true,
							"format": "340"
						}
					},
					{
						"y": 79.55182072829132,
						"dataLabels": {
							"enabled": true,
							"format": "284"
						}
					},
					{
						"y": 75.91036414565826,
						"dataLabels": {
							"enabled": true,
							"format": "271"
						}
					},
					{
						"y": 70.58823529411765,
						"dataLabels": {
							"enabled": true,
							"format": "252"
						}
					},
					{
						"y": 54.90196078431373,
						"dataLabels": {
							"enabled": true,
							"format": "196"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.16957862281603,
						"dataLabels": {
							"enabled": true,
							"format": "926"
						}
					},
					{
						"y": 84.89208633093526,
						"dataLabels": {
							"enabled": true,
							"format": "826"
						}
					},
					{
						"y": 81.19218910585818,
						"dataLabels": {
							"enabled": true,
							"format": "790"
						}
					},
					{
						"y": 75.0256937307297,
						"dataLabels": {
							"enabled": true,
							"format": "730"
						}
					},
					{
						"y": 64.64542651593011,
						"dataLabels": {
							"enabled": true,
							"format": "629"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.81897491821155,
						"dataLabels": {
							"enabled": true,
							"format": "897"
						}
					},
					{
						"y": 90.51254089422028,
						"dataLabels": {
							"enabled": true,
							"format": "830"
						}
					},
					{
						"y": 86.91384950926935,
						"dataLabels": {
							"enabled": true,
							"format": "797"
						}
					},
					{
						"y": 80.37077426390404,
						"dataLabels": {
							"enabled": true,
							"format": "737"
						}
					},
					{
						"y": 68.92039258451473,
						"dataLabels": {
							"enabled": true,
							"format": "632"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.470588235294116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.577464788732399,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.011070110701112,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.830421377183969,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.799136069114468,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.358353510895885,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.594936708860756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.835616438356169,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.181025081788446,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.46934225195095,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.975903614457832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.528230865746554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.24694708276798,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser East<br>n=357"
			},
			{
				"x": 9,
				"text": "Fraser North<br>n=973"
			},
			{
				"x": 15,
				"text": "Fraser South<br>n=917"
			}
		],
		"dataTable": {
			"Fraser East": [
				357,
				340,
				284,
				271,
				252,
				196
			],
			"Fraser North": [
				973,
				926,
				826,
				790,
				730,
				629
			],
			"Fraser South": [
				917,
				897,
				830,
				797,
				737,
				632
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_7.json
// module id = 205
// module chunks = 0